enum PaginationEnum {
  Asc = 'asc',
  Desc = 'desc',
  Max = 50,
  Min = 5,
  Page = 1,
  Size = 10,
}

export default PaginationEnum;
